import React, { FC } from 'react';
import Tooltip from 'HOC/Tooltip';
import Pill from 'Components/Pill';
import injectSheet from 'react-jss';
import { AttributeObject } from '../classes/attributes.classes';
import styleSheet from './styles';

interface Props {
  classes?: any;
  text?: string;
  groupCount?: string;
  attribute?: AttributeObject;
  focusOnHover?: boolean;
}

const EngagementPill: FC<Props> = (props: Props) => {
  const { classes, text, groupCount, attribute, focusOnHover } = props;

  const tooltipDescription = (
    <div>
      <div className={classes.pillDescriptionTitle}>
        Inquiries that match
        <span className={classes.strongText}> ALL </span>
        of the following:
      </div>

      <div>
        {attribute.attributes.map((toolText: string) => {
          const splitted = toolText.split('=');
          return (
            <div key={splitted[0]}>
              {`- ${splitted[0]} = `}
              <span className={classes.strongText}>{splitted[1]}</span>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className={classes.pillContainerHorizontal}>
      <Tooltip
        position="right"
        offsetTop={-5}
        offsetLeft={120}
        text={tooltipDescription}
        width="365px"
        overrideEvents={{
          showToolTip: ['onMouseEnter', 'onFocus'],
          hideToolTip: ['onBlur', 'onMouseLeave'],
        }}
        parentText="Engagement"
      >
        <Pill
          text={text}
          groupCount={groupCount}
          border="1px solid #079DC01A"
          backgroundColor="#079DC01A"
          textColor="#079DC0"
          focusOnHover={focusOnHover}
        />
      </Tooltip>
    </div>
  );
};

EngagementPill.defaultProps = {
  classes: {},
  text: '',
  groupCount: '',
  attribute: { label: '', attributes: [], type: 'engagement' },
  focusOnHover: false,
};

export default injectSheet(styleSheet)(EngagementPill);
